module.exports = __webpack_public_path__ + "static/media/Pool-area.3da0dd95.jpg";